import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import BrandLogo from './BrandLogo';
import { useAuth } from '../contexts/AuthContext';

export default function Layout() {
    const { user, loading } = useAuth();
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    if (loading) {
        return (
            <div className="h-screen w-screen flex items-center justify-center bg-[color:var(--bm-bg)]">
                <div className="text-[color:var(--bm-text-muted)] text-sm">Loading…</div>
            </div>
        );
    }

    if (!user) return <Navigate to="/login" replace />;

    return (
        <div className="flex h-screen w-screen overflow-hidden">
            <Sidebar mobileOpen={mobileNavOpen} onCloseMobile={() => setMobileNavOpen(false)} />
            <div className="flex-1 flex flex-col overflow-hidden">
                {user.is_demo && (
                    <div
                        className="flex items-center justify-center gap-2 h-8 shrink-0 text-[11.5px] font-medium text-amber-900 bg-amber-100 border-b border-amber-200"
                        data-testid="demo-mode-banner"
                    >
                        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse" />
                        You're viewing a live read-only demo with sample data — nothing you see here is real, and changes aren't saved.
                    </div>
                )}
                {/* Mobile-only top bar — hidden on md+ where the persistent sidebar is visible */}
                <div className="md:hidden flex items-center gap-3 px-3 h-14 border-b border-[color:var(--bm-border)] bg-white shrink-0" data-testid="mobile-topbar">
                    <button
                        onClick={() => setMobileNavOpen(true)}
                        className="h-9 w-9 rounded-md flex items-center justify-center text-[color:var(--bm-text-muted)] hover:bg-[color:var(--bm-bg-mute)] transition"
                        aria-label="Open navigation menu"
                        data-testid="mobile-nav-open-btn"
                    >
                        <Menu size={20} />
                    </button>
                    <BrandLogo variant="short" />
                </div>
                <main className="flex-1 overflow-y-auto bg-[color:var(--bm-bg)]" data-testid="main-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
